/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import {
  IFamilyInformationItem,
  Param,
  ParamSize,
} from 'libs/sysque/toolbelt/feature/src/lib/components/add-family-information/add-family-information-types';
import { Observable } from 'rxjs';
import { SysqueElectricalState } from 'libs/sysque/toolbelt/feature/src/lib/models/sysque-electrical-state';
import { ParamCategory } from 'libs/sysque/toolbelt/feature/src/lib/models/add-project-parameter-category';
import { ProjectParameterDataItems } from '@hcworkspace/sysque/toolbelt/feature';
import { ProjectDataParamInfo } from 'libs/sysque/toolbelt/feature/src/lib/models/add-project-data-params-info';
import { ProjectParameterInfo } from 'libs/sysque/toolbelt/feature/src/lib/models/add-project-parameter-info';

export interface IProjectDataFacade {
  addProjectParameter(projectParameterInfo: ProjectParameterInfo): void;
  closeWindow(): void;
  getStorage(key: string): string
  getFamilyInformationResponse(): IFamilyInformationItem;
  readParametersFromDocument(selectedCategory: string): Observable<Param[]>;
  sendPopupRoutingAction(dialogRoute: string): void;
  updateLocalStorage(key: string, value: any): void;
  importExcelClick(paramSizes: ParamSize[]): void;
  exportExcelClick(paramSizes: ParamSize[], fileName: string): void;
  changeDialogDimensions(height: number): void;
  getEditFamilyItem(): IFamilyInformationItem;
  getParamCategories(currentCategory : string): Observable<ParamCategory[]>;
  selectParamCategories(): Observable<ParamCategory[]>;
  initializeAddProjectParametersFromJson(): Observable<ProjectParameterDataItems[]>;
  getDefinitionGroupParameters(): Observable<ProjectDataParamInfo[]> ;
  getBuiltInGroupParameters(): Observable<ProjectDataParamInfo[]> ;
  getProjectParametersNeedToModify(needParam: boolean): Param | Param[];
  getAddProjectParameterResponse(): Param[];
}

export const PROJECT_DATA_FACADE_TOKEN = new InjectionToken<IProjectDataFacade>('PROJECT_DATA_FACADE_TOKEN');
